import { ColumnHelperMethodType } from '../SearchContentTable.types';
import { getAverageViewPercentage } from '../SearchContentTable.utils';
import { TextCell } from '../components/TextCell';

export const ColumnAverageViewPercentage: ColumnHelperMethodType = (
  columnHelper,
) => {
  return columnHelper.accessor((row) => row.contentId, {
    id: 'Average View Percentage',
    cell: ({ row }) => (
      <TextCell>{getAverageViewPercentage(row.original)}</TextCell>
    ),
  });
};
